import { z } from 'zod';
/** Body measurement types that are NOT weight (weight has its own route). */
export const measurementKindSchema = z.enum([
    'body_fat',
    'waist',
    'hip',
    'neck',
    'chest',
    'arm',
    'thigh',
]);
export const createMeasurementSchema = z
    .object({
    type: measurementKindSchema,
    value: z.number().positive().max(10000),
    unit: z.string().trim().min(1).max(10),
    measuredAt: z.string().datetime({ offset: true }),
    timezone: z.string().trim().min(1).max(100).optional(),
})
    .strict();
export const measurementRangeQuerySchema = z
    .object({
    type: measurementKindSchema.optional(),
    from: z.string().date().optional(),
    to: z.string().date().optional(),
    timezone: z.string().trim().min(1).max(100).optional(),
})
    .strict()
    .refine((v) => !v.from || !v.to || v.from <= v.to, {
    message: 'from must be before or equal to to',
    path: ['from'],
});
export const measurementPointSchema = z.object({
    id: z.string().uuid(),
    type: measurementKindSchema,
    localDate: z.string().date(),
    measuredAt: z.string().datetime(),
    value: z.number().positive(),
    unit: z.string(),
    trendValue: z.number().positive(),
});
export const measurementResponseSchema = z.object({
    points: z.array(measurementPointSchema),
});
export const measurementSettingsSchema = z.object({
    measurementsEnabled: z.boolean().nullable(),
});
export const updateMeasurementSettingsSchema = z.object({
    enabled: z.boolean(),
});
//# sourceMappingURL=measurements.js.map